// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import cartLineSharedStyles from "@pace/App/SharedStyles/CartLineSharedStyles";
import { cartLineCardCondensedStyles } from "@pace/Overrides/Widgets/Cart/CartLineCardCondensed";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { css } from "styled-components";

cartLineCardCondensedStyles.mainContainer = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 288px) minmax(0, 213px) minmax(0, 135px) minmax(0, 123px) minmax(0, 149px) minmax(
                0,
                12px
            );
        grid-column-gap: 12px;
        grid-auto-flow: column;
        padding: 0 12px;
        &:not(:last-child) {
            border-bottom: 1px solid ${getColor("common.border")};
        }
        &:nth-child(2n) {
            background: ${getColor("common.ui11")};
        }
        &:last-child {
            border-radius: 0 0 4px 4px;
        }
    `,
};

cartLineCardCondensedStyles.productDescriptionContainer = {
    css: css`
        border-right: 1px solid ${getColor("common.border")};
        padding: 18px 13px 18px 0;
        grid-column: 1 / 2;
    `,
};
cartLineCardCondensedStyles.productDescription = {
    productDetailLink: {
        typographyProps: {
            size: 12,
            lineHeight: "17px",
            weight: fontConfig.weight.bold,
        },
        color: "common.black",
    },
};
cartLineCardCondensedStyles.productErpNumberContainer = {
    css: css`
        border-right: 1px solid ${getColor("common.border")};
        padding: 18px 0;
        grid-column: 2 / 3;
        display: flex;
        flex-direction: column;
    `,
};
cartLineCardCondensedStyles.productErpNumberLabel = {
    size: 12,
    lineHeight: "17px",
    weight: fontConfig.weight.semiBold,
    color: "common.black",
};
cartLineCardCondensedStyles.productErpNumberText = {
    size: 12,
    lineHeight: "17px",
    weight: fontConfig.weight.regular,
    color: "common.ui5",
};
cartLineCardCondensedStyles.productAvailabilityContainer = {
    css: css`
        border-right: 1px solid ${getColor("common.border")};
        padding: 18px 0;
        grid-column: 3 / 4;
    `,
};
cartLineCardCondensedStyles.productAvailability = {
    messageGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            flex-direction: column;
        `,
    },
};

cartLineCardCondensedStyles.quantityContainer = {
    css: css`
        border-right: 1px solid ${getColor("common.border")};
        padding: 18px 0;
        grid-column: 4 / 5;
    `,
};
cartLineCardCondensedStyles.productPriceContainer = {
    css: css`
        border-right: 1px solid ${getColor("common.border")};
        padding: 18px 0;
        grid-column: 5 / 6;
    `,
};
cartLineCardCondensedStyles.productPriceText = {
    variant: "h6",
    forwardAs: "span",
    css: css`
        margin-bottom: 0;
    `,
};
cartLineCardCondensedStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

cartLineCardCondensedStyles.removeCartLineContainer = {
    css: css`
        padding: 18px 0;
        grid-column: 6 / 7;
        align-self: center;
    `,
};
cartLineCardCondensedStyles.removeCartLineIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};

cartLineCardCondensedStyles.specialOrderTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            margin-left: 4px;
        `,
    },
};

cartLineCardCondensedStyles.specialOrderIcon = {
    size: 14,
    color: "common.ui10",
    css: css`
        opacity: 0.5;
    `,
};
